import React from 'react';
import Grid from '@mui/material/Grid2';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

const SuggestionPopup = (props) => {
    const {
        showModal,
        setShowModal,
        timeRange = "00:00 - 00:00",
        totalEmployees = 0,
        estimatedNeed = 0,
        overStaffedGroups = ""
    } = props;

    return (
        <Dialog
            open={showModal}
            onClose={() => setShowModal(false)}
            fullWidth
            maxWidth='sm'
        >
            <Grid
                container
                spacing={0}
                alignItems="center"
                className="changes_popup"
            >
                <Grid className="popup_body_container">
                    <Grid>
                        <Typography className="caution_popup_header">
                            How did we get this prediction?
                        </Typography>
                        <div style={{marginBottom: 15, marginTop: 20}}>
                                <Typography className="popup_detail_text">
                                    <span style={{fontWeight: 600}}>Total employees on shift during {timeRange}:</span> <span style={{fontWeight: 400}}>{totalEmployees}</span>
                                </Typography>
                                <Typography className="popup_detail_text">
                                    <span style={{fontWeight: 600}}>Estimated operational need:</span> <span style={{fontWeight: 400}}>{estimatedNeed}</span>
                                </Typography>
                        </div>
                        <div>
                            <Typography className="popup_detail_text">
                                <span style={{fontWeight: 600}}>Role with estimated over staffing:</span> <span style={{fontWeight: 400}}>{overStaffedGroups}</span>
                            </Typography>
                        </div>
                    </Grid>
                </Grid>
            </Grid>
        </Dialog>
    );
};

export default SuggestionPopup;